"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crossCheckSynthetic = crossCheckSynthetic;
// SPEC §14.4 "keys refer to organization.yaml practices": every practice a synthetic document names must
// be a practice of some ACO in the organization. Each document has
// already parsed on its own; issues are reported against the synthetic document holding the reference.
const config_issue_js_1 = require("./config-issue.js");
const organization_js_1 = require("./organization.js");
function practiceReferences(doc) {
    return doc.practices.map((entry, p) => ({
        path: ["practices", p, "practice"],
        practice: entry.practice,
    }));
}
/** Every practice a synthetic document names that the organization does not; keyed by file stem. */
function crossCheckSynthetic(organization, synthetic) {
    const known = new Set((0, organization_js_1.organizationPractices)(organization).map((practice) => practice.name));
    return Object.entries(synthetic).flatMap(([name, doc]) => practiceReferences(doc)
        .filter((reference) => !known.has(reference.practice))
        .map((reference) => ({
        document: `synthetic/${name}`,
        path: (0, config_issue_js_1.formatIssuePath)(reference.path),
        message: `TIN Name ${reference.practice} is not in organization`,
    })));
}
//# sourceMappingURL=synthetic-cross-check.js.map